import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import ImageUploader from 'vue-image-upload-resize'
import * as VueGoogleMaps from 'vue2-google-maps'
import "./assets/cwcontent.css";


Vue.use(ImageUploader);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
  }
})

Vue.config.productionTip = false

Vue.prototype.$APP_API_URL = process.env.VUE_APP_API_URL;
Vue.prototype.$CAPTCHA_KEY = process.env.VUE_APP_CAPTCHA_KEY;
Vue.prototype.$MAIL_API_URL = process.env.VUE_APP_MAIL_API_URL;
Vue.prototype.$ERROR_MAIL_API_URL = process.env.VUE_APP_ERROR_MAIL_API_URL;
Vue.prototype.$ERROR_MAIL_API_URL_2 = process.env.VUE_APP_ERROR_MAIL_API_URL_2;
Vue.prototype.$LANG = process.env.VUE_APP_I18N_LOCALE;
Vue.prototype.$CANDIDATES_API_URL = process.env.VUE_APP_CANDIDATES_API_URL;
Vue.prototype.$VUE_APP_BACKUP_DATA = process.env.VUE_APP_BACKUP_DATA;

new Vue({
    i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
